(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    /*
   * Hover shows the second image as a cross-faded overlay; the arrows drive the
   * carousel underneath. This hands one to the other.
   *
   * The first arrow click is taken over entirely, and resolved in one jump.
   *
   * Two things that look reasonable both fail. Letting the slideshow run its
   * own next() after putting it on the overlay's picture advances from a stale
   * index and lands on the image the overlay already shows. Two selects in a
   * row — onto the overlay's picture, then one step on — fail because select()
   * marks the slideshow busy for its transition and ignores the second call.
   *
   * So the carousel jumps once, without animation, straight to the slide one
   * step past the overlay's. The jump happens under the overlay, which then
   * fades out, so it still reads as a cross-fade. Later clicks are the
   * slideshow's own.
   */
  (() => {
    if (window.sanyCardHover) return;
    window.sanyCardHover = true;

    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('.slideshow-control--next, .slideshow-control--previous');
      const card = arrow?.closest('.product-card');
      const overlay = card?.querySelector('.sany-card-hover');
      if (!overlay || card.classList.contains('sany-browsing')) return;

      const slideshow = card.querySelector('slideshow-component');
      const slides = slideshow?.slides || [];
      const from = slides.findIndex((slide) => slide.getAttribute('slide-id') === overlay.dataset.mediaId);
      if (from < 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const step = arrow.classList.contains('slideshow-control--next') ? 1 : -1;
      const to = (from + step + slides.length) % slides.length;

      slideshow.select(to, undefined, { animate: false });
      card.classList.add('sany-browsing');
    }, true);

    // Leaving the card puts it back on its cover, so the next hover starts clean.
    document.addEventListener('pointerout', (event) => {
      const card = event.target.closest?.('.product-card.sany-browsing');
      if (!card || card.contains(event.relatedTarget)) return;
      card.classList.remove('sany-browsing');
      const slideshow = card.querySelector('slideshow-component');
      slideshow?.select(slideshow.initialSlideIndex ?? 0, undefined, { animate: false });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sany-ingredients"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sany-ingredients')) {
    class SanyIngredients extends HTMLElement {
      connectedCallback() {
        this.sync = this.sync.bind(this);
        this.queue = () => setTimeout(this.sync, 60);
        this.scope = this.closest('.shopify-section') || document;
        // A flavor change shows up as a change event from the picker and a new
        // ?variant= in the address bar; either is enough to re-check.
        this.scope.addEventListener('change', this.queue);
        window.addEventListener('popstate', this.queue);
        this.observer = new MutationObserver(this.queue);
        const idInput = this.scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (idInput) this.observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
        this.sync();
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.queue);
        window.removeEventListener('popstate', this.queue);
        this.observer?.disconnect();
      }

      selectedId() {
        const fromUrl = new URLSearchParams(location.search).get('variant');
        if (fromUrl) return fromUrl;
        return this.scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value || '';
      }

      sync() {
        const id = this.selectedId();
        const panels = [...this.querySelectorAll('.sany-ingredients__panel')];
        if (!id) return;
        let shown = false;
        for (const panel of panels) {
          const match = panel.dataset.variantId === id;
          panel.hidden = !match;
          shown ||= match;
        }
        this.hidden = !shown;
      }
    }

    customElements.define('sany-ingredients', SanyIngredients);
  }
  } catch(e) { console.error(e); }
})();

})();
